import { memo } from "react";
import { Handle, type NodeProps } from "@xyflow/react";
import { Flag, StopCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import type { EmitOutputNodeData } from "@/types/decision-graph";
import { getHandlePositions } from "../utils/handle-positions";

export const EmitOutputNode = memo(function EmitOutputNode({
  data,
  selected,
}: NodeProps) {
  const d = data as EmitOutputNodeData;
  const { inputPosition } = getHandlePositions(d.layoutDirection);

  return (
    <div
      className={cn(
        "px-4 py-3 rounded-lg border-2 bg-white shadow-sm min-w-[130px]",
        "transition-all duration-150",
        selected
          ? "border-amber-500 shadow-md ring-2 ring-amber-200"
          : "border-amber-300 hover:border-amber-400"
      )}
    >
      <Handle
        type="target"
        position={inputPosition}
        id="input"
        style={{ background: "#f59e0b", width: 8, height: 8 }}
      />

      <div className="flex items-center gap-2 mb-1">
        <Flag size={14} className="text-amber-600" />
        <span className="text-xs font-semibold text-amber-700">Output</span>
        {d.stopProcessing && (
          <span title="Stop processing">
            <StopCircle size={12} className="text-red-500" />
          </span>
        )}
      </div>

      <div className="text-xs font-medium text-slate-700 truncate max-w-[140px]">
        {d.label || "Unnamed"}
      </div>

      {d.outcome && (
        <div
          className={cn(
            "mt-1 px-2 py-0.5 rounded text-[10px] font-medium inline-block",
            "bg-amber-100 text-amber-800 border border-amber-200"
          )}
        >
          {d.outcome}
        </div>
      )}
    </div>
  );
});
